import { Region } from '../shared/types';
import { usePreferences } from './usePreferences';

const useLookupPageStockRegion = (stockRegion?: Region): Region => {
  const { region } = usePreferences();
  return window.location.pathname.startsWith('/lookup') ? stockRegion : region;
};

export default useLookupPageStockRegion;
